var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"template-loading module"},[_c('div',{staticClass:"template-loading__anchor"},[_c('ResponsiveImageRatio',{staticClass:"template-loading__image",attrs:{"ratio":"1x1","image":{
        Url: _vm.imageUrl,
        Alt: _vm.imageAlt,
        OriginalWidth: 256,
        OriginalHeight: 256,
      },"widths":_vm.imageWidths}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }